import React, { useState, useEffect } from "react";
import { BlobProvider } from "@react-pdf/renderer";
import { useShared } from "../../hooks/useShared";
import AMenu from "./AMenu";
import MainSection from "../../components/sections/MainSection";
import { useParams } from "react-router-dom";
import APopover from "../../components/partials/APopover";
import { ToastContainer } from "react-toastify";
import InvoicePdf from "./InvoicePdf";
import { Chip, Spinner } from "@material-tailwind/react";
import { getLanguage } from "react-multi-lang";
import PDFGenerateModal from "../../components/modals/PDFGenerateModal";
import ASpinner from "../../components/partials/ASpinner";

const TABLE_HEAD = [
  "#",
  "ID",
  "شماره",
  "نوع",
  "تاریخ صدور",
  "طريق صدور",
  "شرکت",
  "کشور",
  "اجناس",
  "حالت اينوايس",
  "ای دی تعرفه",
  "فايل",
  "تاریخ",
  "اقدامات"
];
const breadcrumbs = [{ name: "اينوايس‌ها", link: "/invoices" }];

const searchInputFields = [
  {
    label: "ID",
    name: "invoice_id_number",
    type: "text",
    roles: [1, 2, 4, 17],
    icon: "text-outline",
    className: "md:col-span-2"
  },
  {
    label: "نوع اينوايس",
    name: "sInvoice_type",
    type: "select",
    roles: [1, 2, 4, 18],
    icon: "text-outline",
    className: "md:col-span-2",
    options: [
      { value: 1, label: "صادرات" },
      { value: 2, label: "واردات" }
    ]
  },
  {
    label: "شــرکت",
    name: "sCompany",
    type: "select",
    roles: [1, 2, 18],
    icon: "text-outline",
    className: "md:col-span-2",
    options: []
  },
  {
    label: "ارسال (کشــور)",
    name: "shipping_state",
    type: "select",
    roles: [1, 2, 4, 18],
    icon: "text-outline",
    className: "md:col-span-2",
    options: []
  },
  {
    label: "تاريخ صدور",
    name: "shipping_date",
    type: "pdate",
    roles: [1, 2, 4, 18],
    icon: "text-outline",
    className: "md:col-span-2"
  },
  {
    label: "شماره اينوايس",
    name: "invoice_number",
    type: "text",
    roles: [1, 2, 4, 18],
    icon: "text-outline",
    className: "md:col-span-2"
  },
  {
    label: "ايجاد کننده",
    name: "creator_id",
    type: "select",
    roles: [1, 2, 18],
    icon: "text-outline",
    className: "md:col-span-2"
  }
];

const csvHeaders = [
  { label: "#", key: "index" },
  { label: "Invoice Number", key: "invoice_number" },
  { label: "From", key: "from" },
  { label: `--Items----`, key: "items" },
  { label: "Currency", key: "currency" },
  { label: "Ship To", key: "ship_to" },
  { label: "Shipping Date", key: "shipping_date" },
  { label: "Generating Date", key: "date" },
  { label: "Status", key: "status" },
  { label: "Added By", key: "creator_id" }
];

export default function Invoices() {
  const params = useParams();
  const {
    http,
    com,
    consts,
    model,
    setModel,
    auth,
    models,
    navigate,
    setShowViewDialog,
    showDeleteDialog,
    setShowDeleteDialog,
    setShowFilesModal,
    setOpenUploadFileDialog,
    location,
    setOpenApproveDialog,
    generatePDF,
    setGeneratePDF
  } = useShared();

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!auth.hasRole([1, 2, 4, 18])) {
      return navigate("/db/notAllowed");
    }
  }, []);

  const handleMenu = (model, flag = false) => {
    console.log("handleMenu ", model, flag);
    setModel(model);
    if (flag === "delete") {
      //  setModel(model)
      setShowDeleteDialog(!showDeleteDialog);
    }
    if (flag === "edit") {
      // setModel(model)
      navigate(`/db/invoices/0/new_invoice/${model.id}`, {
        state: { modelName: { name: "invoices", af: "اينوايس" }, model }
      });
    }
    if (flag === "view") {
      // setModel(model)
      setShowViewDialog(true);
    }

    if (flag === "pdf") {
      getImage(model);
    }

    if (flag === "upload file") {
      console.log("upload file");
      setModel(model);
      setOpenUploadFileDialog(pre => !pre);
    }

    if (flag === "approve") {
      console.log(flag);
      if (auth.hasRole([1, 2, 18])) {
        setModel(model);
        setOpenApproveDialog(pre => !pre);
      }
    }
  };

  const getImage = async model => {
    console.log("get image", model);
    try {
      setLoading(true);
      if (model?.company?.image_data) {
        const res = await http.post("api/getImage", {
          path: model?.company?.image_data?.path
        });
        console.log("getImage ", res);
        if (res.data.success) {
          const data = res?.data?.data;
          model["mImage"] = data[0];
          setGeneratePDF(true);
        }
        setLoading(false);
      } else {
        setGeneratePDF(true);
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
      console.log("getImage base64  error ", error);
    }
  };

  const openFilesDialog = model => {
    if (model?.attachments?.length > 0) {
      setModel(model);
      setShowFilesModal(true);
    }
  };

  const gotoToTariffs = tId => {
    navigate(`/db/tariffs/${tId}`);
  };

  const handleViewDialog = obj => {
    return [
      { l: "Name", v: obj?.name },
      { l: "Type", v: obj?.parent?.label },
      { l: "Description", v: obj?.description },
      { l: "Added by", v: obj?.user?.full_name },
      { l: "Status", v: obj?.status },
      { l: "Last Update", v: com.ddmmyyhhmmA(obj?.updated_at) }
    ];
  };

  const getTableData = () => {
    return (
      <tbody className="">
        {models?.data?.map((r, i) => {
          return (
            <tr key={i}>
              <td>{models?.from + i}</td>
              <td>{r?.id}</td>
              <td>{r?.company_inovice_number}</td>
              <td>{r?.invoice_type?.label}</td>
              <td>{com.dateConvert(r?.shipping_date, false)}</td>
              <td>{r?.export_type?.label}</td>
              <td>
                {r?.invoice_type?.value === 1 ? (
                  <>
                    {" "}
                    <span>{r?.company?.name_af}</span>{" "}
                    <APopover
                      v={{
                        data: shippingPopup(r),
                        className: "mt-3",
                        btn: "!bg-green-900/30",
                        iconCss: "!text-green-900"
                      }}
                    />{" "}
                  </>
                ) : (
                  <>
                    <span>{r?.shipping_state?.name_af}</span>{" "}
                    <APopover
                      v={{
                        data: shippingPopup(r, false),
                        className: "mt-3",
                        btn: "!bg-green-900/30",
                        iconCss: "!text-green-900"
                      }}
                    />
                  </>
                )}
              </td>
              <td>
                {r?.invoice_type?.value === 1 ? (
                  <>
                    <span>{r?.shipping_state?.name_af}</span>{" "}
                    <APopover
                      v={{
                        data: shippingPopup(r, false),
                        className: "mt-3",
                        btn: "!bg-blue-900/30",
                        iconCss: "!text-blue-900"
                      }}
                    />
                  </>
                ) : (
                  <>
                    {" "}
                    <span>{r?.company?.name_af}</span>{" "}
                    <APopover
                      v={{
                        data: shippingPopup(r),
                        className: "mt-3",
                        btn: "!bg-blue-900/30",
                        iconCss: "!text-blue-900"
                      }}
                    />{" "}
                  </>
                )}
              </td>

              <td style={{ direction: "rtl" }}>
                <div>${com?.NumberFormatter(r?.amount)} </div>
                {r?.tariff?.items?.map((item, j) => {
                  return (
                    <span key={j} className="ml-1">
                      {item?.category.label}
                      {j < r?.tariff?.items?.length - 1 && <span>،</span>}{" "}
                    </span>
                  );
                })}
                <APopover
                  v={{ data: itemsPopup(r?.tariff?.items), className: "mt-3" }}
                />
              </td>
              <td>
                {" "}
                <Chip
                  onClick={() =>
                    handleMenu(
                      r,
                      r?.status === 0
                        ? "upload file"
                        : r?.status === 1
                        ? "approve"
                        : ""
                    )
                  }
                  className=" cursor-pointer capitalize text-center px-1"
                  variant="ghost"
                  size="sm"
                  color={
                    r.status === 0 && r.attachments?.length === 0
                      ? "gray"
                      : r.status === 1
                      ? "orange"
                      : r.status === 2
                      ? "green"
                      : r.status === -1
                      ? "red"
                      : ""
                  }
                  value={
                    r.status === 0 && r.attachments?.length === 0
                      ? "لطفا اينوايس امضا شده را آپلود کنيد"
                      : r.status === 1
                      ? "منتظر تاييد"
                      : r.status === 2
                      ? "تکمیل شد"
                      : r.status === -1
                      ? "رد شد"
                      : "error"
                  }
                />
              </td>

              <td className="text-center">
                {" "}
                <span
                  className=" cursor-pointer text-blue-800 underline"
                  onClick={() => gotoToTariffs(r?.invoice_tariff?.value)}
                >
                  {r?.invoice_tariff?.value}
                </span>
              </td>
              <td className="text-center">
                {" "}
                <span
                  className=" cursor-pointer text-blue-600"
                  onClick={() => openFilesDialog(r)}
                >
                  ({r?.attachments?.length})
                </span>
              </td>

              <td style={{ direction: "ltr" }}>
                {com.dateConvert(r?.created_at, false, true)}
                <p>{r?.user?.full_name}</p>
              </td>
              <td>
                <AMenu
                  v={{
                    handleMenu: (row, flag) => handleMenu(row, flag),
                    model: r
                  }}
                />
              </td>
            </tr>
          );
        })}
      </tbody>
    );
  };

  const itemsPopup = items => (
    <table
      className=" gTable  "
      style={{ direction: getLanguage() === "dr" ? "rtl" : "ltr" }}
    >
      <thead>
        <tr className="!bg-deep-purple-900/20 !text-deep-purple-500">
          <th>#</th>
          <th>جنس</th>
          <th>متراژ</th>
          <th>نرخ حمايوی فی متر</th>
          <th>نرخ واقعی فی متر</th>
          <th>وزن KG</th>
          <th>سورت</th>
          <th>قطعه</th>
          <th>بندل</th>
          <th>توتال</th>
          <th>توضحات</th>
        </tr>
      </thead>
      <tbody>
        {items?.map((item, i) => (
          <tr key={i + 1}>
            <td>{1 + i}</td>
            <td>{item?.category?.label} </td>
            <td> {item?.quantity} </td>
            <td> {item?.price_per_unit} ؋</td>
            <td> {item?.real_price_per_unit} ؋</td>
            <td> {item?.weight}</td>
            <td> {item?.sort}</td>
            <td> {item?.pieces}</td>
            <td> {item?.bales}</td>
            <td>
              {" "}
              {com?.NumberFormatter(item?.quantity * item?.price_per_unit)} ؋
            </td>
            <td> {item?.description}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );

  const shippingPopup = (r, flag = true) => (
    <>
      {" "}
      {flag ? (
        <table
          className=" gTable  "
          style={{ direction: getLanguage() === "dr" ? "rtl" : "ltr" }}
        >
          <tbody>
            <tr className="!bg-deep-purple-900/20 !text-deep-purple-500">
              <th colSpan={2}>شرکت</th>
            </tr>
            <tr>
              <th>نام</th>
              <td>{r?.company?.name_af}</td>
            </tr>
            <tr>
              <th>اردرس</th>
              <td>{r?.company?.address}</td>
            </tr>
            <tr>
              <th> شماره TIN </th>
              <td>{r?.company?.tin_number}</td>
            </tr>
            <tr>
              <th>شماره جواز </th>
              <td>{r?.company?.license_number}</td>
            </tr>
            <tr>
              <th>مالک</th>
              <td>{r?.company?.owner?.label}</td>
            </tr>
            <tr>
              <th>ايميل</th>
              <td>{r?.company?.email}</td>
            </tr>
          </tbody>
        </table>
      ) : (
        <table
          className=" gTable  "
          style={{ direction: getLanguage() === "dr" ? "rtl" : "ltr" }}
        >
          <tbody>
            <tr className="!bg-deep-purple-900/20 !text-deep-purple-500">
              <th colSpan={2}>ارسال به</th>
            </tr>
            <tr>
              <th>نام مشتری</th>
              <td>{r?.shipping_name}</td>
            </tr>
            <tr>
              <th>ادرس</th>
              <td>{r?.shipping_address}</td>
            </tr>
            <tr>
              <th>شهر</th>
              <td>{r?.shipping_city}</td>
            </tr>
            <tr>
              <th>کشور</th>
              <td> {r?.shipping_state?.label}</td>
            </tr>
            <tr>
              <th>شماره تماس</th>
              <td>{r?.shipping_phone}</td>
            </tr>
            <tr>
              <th>ايميل</th>
              <td>{r?.shipping_email}</td>
            </tr>
          </tbody>
        </table>
      )}
    </>
  );

  return (
    <>
      <MainSection
        v={{
          handleViewDialog,
          searchInputFields,
          newModelInputFields: [{ test: "new page" }],
          TABLE_HEAD,
          breadcrumbs,
          tableData: getTableData(),
          addNewItemTitle: "انوايس جديد",
          tableTitle: "لست انوايس‌ها",
          url: "invoices",
          mUrl: {
            delete: "invoices",
            create: "invoices",
            getAll: "invoicesAdvanceSearch"
          },
          modelName: { name: "invoices", af: "اينوايس" },
          advanceSearch: "invoicesAdvanceSearch",
          attachName: "Invoice",
          searchData: {
            sCompany: { value: location?.state?.company_id },
            invoice_id: params.id
          },
          csv: { csvHeaders, show: true }
        }}
      />

      <ToastContainer />
      {generatePDF && <PDFGenerateModal v={{ modelName: "Invoice" }} />}
      {loading && <ASpinner />}
    </>
  );
}
